import styled from 'styled-components';

import { screen } from '../../variables';

export default function Wrapper(props) {
  const {
    nav,
    children,
    color,
    customMobileMargin,
    flex,
    footer,
    iconBar,
    padding,
    margin,
    width,
    className,
  } = props;

  return (
    <StyledWrapper
      nav={nav}
      footer={footer}
      color={color}
      flex={flex}
      padding={padding}
      margin={margin}
      customMobileMargin={customMobileMargin}
      width={width}
      className={className}
      iconBar={iconBar}
    >
      {children}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  box-sizing: border-box;
  color: ${(props) => props.color || '#464949'};
  width: 100%;
  max-width: ${(props) => props.width || '1070px'};
  padding: ${(props) => props.padding || '0'};
  margin: ${(props) => props.margin || '0 auto'};

  @media (max-width: ${screen.tablet}px) {
    margin: ${(props) => props.customMobileMargin || props.margin || '0 auto'};
  }

  ${(props) =>
    props.flex &&
    `display: flex;
     justify-content: space-between;

     @media (max-width: ${screen.tablet}px) {
      flex-flow: row wrap;
      display: flex;
      justify-content: center;
     }`}

  ${(props) =>
    props.nav &&
    `@media (max-width: ${screen.tablet}px) {
      justify-content: space-between;
    }`}

  ${(props) =>
    props.footer &&
    `@media (max-width: ${screen.tablet}px) {
      justify-content: flex-start;
    }`}

  ${(props) => props.nav && `align-items: center;`}

  ${(props) =>
    props.iconBar &&
    `@media (max-width: 830px) {
      flex-direction: column;
      align-items: center;
    }
    `}
`;
